import { useState, useEffect } from 'react';
import { authFetch } from '../../components/Auth/apiClient';
import { getUserInfo } from '../../components/Auth/fetchUser';

export const usePresence = (instance, campaignId, userName) => {
    const [activeGrids, setActiveGrids] = useState({});

    useEffect(() => {
        const pollPresence = async () => {
            try {
                const response = await authFetch(instance, `/api/presence/${campaignId}`);
                const data = await response.json();
                setActiveGrids(data.grids);
                //console.log(data);
            } catch (error) {
                console.log('Presence poll failed:', error);
            }
        };

        pollPresence();
        const interval = setInterval(pollPresence, 10000);
        return () => clearInterval(interval);
    }, [campaignId]);

    const updatePresence = (gridId) => {
        authFetch(instance, `/api/presence/${campaignId}/${gridId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_name: userName })
        });
    };

    const deletePresence = (gridId) => {
        authFetch(instance, `/api/presence/${campaignId}/${gridId}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_name: userName })
        });
    };

    return { activeGrids, userName, updatePresence, deletePresence };
};